/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */
export function verifyResponseLog(response) {
  if (response && response.ok) {
    console.log('Verify endpoint response OK: ', response.ok);
    if (response.data) {
      console.log('Verify endpoint response data is available: ', response.data);
    } else {
      console.log('Verify endpoint response data is not available: ', response);
    }
  } else {
    console.log('Verify endpoint data not ok: ', response.data);
  }
}
